'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventRegistrationRoutes = [
  {
    path: 'registrations',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.registration.list',
        props: true,
        component: () => import('../views/RegistrationListView.vue'),
      },
    ],
  },
];

export const eventManageRegistrationRoutes = [
  {
    path: 'registrations',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.registration.list',
        props: true,
        component: () => import('../views/ManageRegistrationListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.registration.add',
        props: true,
        component: () => import('../views/ManageRegistrationAddView.vue'),
      },
      {
          path: ':registrationId',
          component: EmptyRouterView,
          props: true,
          children: [
            {
              path: 'edit',
              name: 'event.manage.registration.edit',
              props: true,
              component: () => import('../views/ManageRegistrationEditView.vue'),
            },
          ],
        },
    ],
  },
];
